import { createFileRoute } from '@tanstack/react-router'
import { IdentityEngagementTab } from '@/components/identities/identity-tabs'

export const Route = createFileRoute('/o/$org/identities/$id/engagement')({
  component: () => <IdentityEngagementTab identityId={Route.useParams().id} />,
})
